import { Fragment, ReactNode } from "react"
import Footer from "components/footer"
import Header from "components/header"

interface IPageTemplate {
    children: ReactNode,
    isFooter?: boolean
    isHeaderChange?: boolean
    background?: string
    overLay?: boolean
}

const PageTemplate = ({
    children, isFooter = true, isHeaderChange = false, background, overLay = false
}: IPageTemplate) => {
    return (
        <Fragment>
            <section className={`${background ? background : 'bg-base'}`}>
                <Header
                    isHeaderChange={isHeaderChange}
                    isOverLay={overLay}
                />
                {children}
                {
                    isFooter &&
                    <Footer />
                }
            </section>
        </Fragment>
    )
}

export default PageTemplate